// extracted by mini-css-extract-plugin
export var gif = "_hy-0";